import { useTranslation } from 'react-i18next';
import { Button, Modal, Label, InputText, Switch } from '@teo/components';
import { useState, useContext } from 'react';
import { config } from '@/config';
import { axios } from '@/axios';
import { AuthContext } from '@/components/Contexts/AuthContext';
import { InformationFilled } from '@teo/components/icons';

function TagModal({
  setIsOpenTagModal,
  isOpenTagModal,
  closeModal,
  onChange,
  isAddModal,
  isTagIndex,
  activeTag,
  activeTags,
}: any) {
  const { t } = useTranslation();
  const { auth } = useContext(AuthContext);

  const [tagName, setTagName] = useState('');

  function submitNewTag() {
    axios
      .post(`${config.backend}/tags`, {
        tag: tagName,
        organisationId: auth?.user?.activeOrganisationId,
        lang: auth?.user?.lang,
        primary: primary,
      })
      .then((data) => onChange(data));
  }

  const [primary, setPrimary] = useState(
    activeTag?.primary ? activeTag?.primary : false
  );

  function editNewTag() {
    axios
      .put(`${config.backend}/tag/${activeTag.id}`, {
        tag: tagName ? tagName : activeTag.tag,
        updatedAt: new Date().toJSON(),
        primary: primary,
      })
      .then((data) => onChange(data));
  }
  const handleButton = () => {
    setIsOpenTagModal(false);
    isAddModal ? submitNewTag() : editNewTag();
  };

  return (
    <div className="bg-white">
      <div className="fixed inset-0 z-[100] flex rounded-xl bg-white/75 px-3">
        <div className="mx-auto my-8 h-max w-full max-w-[640px]  rounded-xl bg-white drop-shadow-m">
          <Modal.Header onClose={closeModal}>
            <h2 className="text-sm font-semibold" data-testid="addTagsHeader">
              {isAddModal
                ? t('pages.manage_tags.modal_title')
                : t('pages.manage_tags.edit_tag')}
            </h2>
          </Modal.Header>

          <Modal.Body>
            <h1 className="text-base font-semibold">
              {isAddModal
                ? t('pages.manage_tags.modal_title')
                : t('pages.manage_tags.edit_tag')}
            </h1>
            <p className="mt-2 text-sm font-normal text-[#7d7d81]">
              {isAddModal
                ? t('pages.manage_tags.modal_subtitle')
                : t('pages.manage_tags.modal_subtitle_edit')}
            </p>

            <form
              className="w-full  flex-col max-md:h-full max-md:overflow-hidden"
              data-testid="addTagsForm"
            >
              <div>
                <Label htmlFor="tagName">
                  <p className="mt-6 text-sm font-semibold">
                    {t('pages.manage_tags.tag_name_label')}
                  </p>
                </Label>
                <InputText
                  id="tagName"
                  type="text"
                  onChange={(e) => setTagName(e.target.value)}
                  placeholder={
                    isAddModal
                      ? t('pages.manage_tags.tag_name_placeholder')
                      : activeTag?.tag
                  }
                  value={tagName}
                  data-testid="addNameTag"
                />
              </div>
              <div className="mt-5">
                {activeTags?.length >= 5 && !activeTag?.primary && (
                  <div className="mb-2 flex w-full flex-row items-center gap-1 rounded-lg bg-tint-blue-light p-3">
                    <InformationFilled className="h-6 w-6 text-tint-blue" />
                    <p
                      className="text-sm text-[#004795]"
                      dangerouslySetInnerHTML={{
                        __html: t('pages.manage_tags.primary_tags_limit'),
                      }}
                    ></p>
                  </div>
                )}
                <div className="flex flex-row items-center gap-4 rounded-lg border border-grey-02 p-4">
                  <div data-testid="product-learning-path">
                    <Switch
                      checked={primary}
                      disabled={activeTags?.length >= 5 && !activeTag?.primary}
                      onChange={(isCheck) => {
                        setPrimary(isCheck);
                      }}
                    />
                  </div>
                  <div>
                    <h4 className="font-normal">
                      {t('pages.manage_tags.primary_tags')}
                    </h4>
                    <p className="text-xs text-grey-05">
                      {t('pages.manage_tags.primary_tags_desc')}
                    </p>
                  </div>
                </div>
              </div>
            </form>
          </Modal.Body>

          <Modal.Footer
            cancelButtonLabel={t('pages.manage_tags.cancel_button')}
            onCancel={closeModal}
          >
            <div data-testid="addTagsFooter">
              <Button
                type="button"
                onClick={handleButton}
                disabled={
                  tagName.length < 1 && activeTag?.primary === primary
                    ? true
                    : false
                }
                data-testid="addBtn"
              >
                {isAddModal
                  ? t('pages.manage_tags.add_tag_button')
                  : t('pages.manage_tags.edit_tag')}
              </Button>
            </div>
          </Modal.Footer>
        </div>
      </div>
    </div>
  );
}

export default TagModal;
